module.exports = __webpack_public_path__ + "i18n/ko.9b15b22391605206396daab9f6950a6d.json";